import { render } from "./OlabFlask.vue?vue&type=template&id=2154d383&scoped=true"
import script from "./OlabFlask.vue?vue&type=script&lang=js"
export * from "./OlabFlask.vue?vue&type=script&lang=js"

import "./OlabFlask.vue?vue&type=style&index=0&id=2154d383&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2154d383"]])

export default __exports__